module.exports = __webpack_public_path__ + "fonts/visuelt-pro-medium.be833d0b.ttf";